export const themecolors = {
    dark_background_1: '#121212',
    dark_background_2: '#161616',
    dark_background_3 : '#222222',
    dark_background_4: '#252525',
    dark_background_5: '#272727',
    dark_background_6: '#2c2c2c',
    dark_background_7: '#2e2e2e',
    dark_background_8: '#333333',
    dark_background_9: '#363636',
    dark_background_10: '#383838',
    dark_high_impact_text: 'oklch(0.985 0 0)',
    dark_medium_impact_text: 'oklch(0.708 0 0)',
    dark_low_impact_text: 'oklch(0.556 0 0)',
    light_high_impact_text: 'oklch(0.145 0 0)',
    light_medium_impact_text: 'oklch(0.371 0 0)',
    light_low_impact_text: 'oklch(0.556 0 0)',
    pure_white: '#fff',
    pure_black: '#000',
    light_input: '#edeff0d9',
    light_border: '#dfdfdf',
    lighter_border: '#e4e4e4',
    lightest_border: '#eeeeee',
    upvote_orange: '#f08f36',
    downvote_blue: '#447ef7',
    red: '#d42e23',
    green: '#38803f',
    link: '#369',
};